import { v4 as uuidv4 } from 'uuid';
import WishlistHelper from "../../utils/wishlist-helper";

export default class CarSaveForLater {
    constructor(parent) {
        this.parent = parent;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.finance = parent.finance;
    }

    async save() {        
        const wishlistData = await WishlistHelper.create();
        const carData = this.car.data();
        const colourTrim = this.car.colourTrim();
        const accessoriesWithoutWheelData = this.car.accessoriesWithoutWheelData();
        const data = {
            type: 'HondaCarConfiguratorOffer',
            id: this.uuid(),
            synced: false,
            model: this.data.model.modelBodyCode,
            vehicleName: this.data.model.modelBodyName,
            carBasePrice: this.pricing.getCarBasePrice(),
            carTotalPrice: this.pricing.getCarTotalPrice(),
            trim: colourTrim.trimName,
            carTrimCode: colourTrim.trim,
            carLongUrl: window.location.href,
            gradeEngine: `${carData.gradeName}|${carData.engineName} ${carData.transmissionName} ${carData.drivetrain}`,
            gradeEngineCode: `${carData.gradeCode}|${carData.engineTDCode}`,
            carColour: colourTrim.colourName,
            carColourCode: colourTrim.colour,
            selectedAccessoriesWithoutStandardAlloys: accessoriesWithoutWheelData.map((a) => a.description).join(),
            specId: null,
            financeOfferDesc: this.toFinanceString(),
            financeParams: this.financeParams(),
            servicingSelected: false,
            shareWithDealer: false,
            dateCreated: new Date().toISOString(),
            mtoce: this.car.mtoce(),
            wishlistId: wishlistData?.wishlistId ?? '',
            shareCode: wishlistData?.shareCode ?? '',
        };

        window.HONDA.SaveForLater.save(data);
        return data;
    }

    uuid() {
        return uuidv4();
    }

    financeParams() {
        const result = this.finance.type !== 'cash' && this.finance.result ? this.finance.result : {};
        return {
            'finance-offer-term': result.term?.term,
            'finance-offer-mileage': result.expectedUsage?.value,
            'finance-offer-deposit': result.payments?.deposit?.grossValue,
            'finance-offer-type': this.finance.type,
            'finance-final-payment': null, // TODO: Open query
            'finance-honda-deposit': this.finance.getFinanceContribution(),
            'finance-interest-rate': result.rates?.nominalRate?.percentage,
            'finance-interest-rate-representative': result.rates?.effectiveRate?.percentage,
            'finance-offer-expiry': null, // TODO: Not in solifi response
            'finance-monthly-installment': result.payments?.regularPayment?.grossValue,
        };
    }

    toFinanceString() {
        const obj = new URLSearchParams(this.toFinance());
        return obj.toString();
    }

    toFinance() {
        const result = this.finance.type !== 'cash' && this.finance.result ? this.finance.result : {};
        return {
            financeOfferTerm: result.term?.term,
            financeOfferMileage: result.expectedUsage?.value,
            financeOfferDeposit: result.payments?.deposit?.grossValue,
            financeOfferType: this.finance.type,
            financeFinalPayment: null,
            financeHondaDeposit: this.finance.getFinanceContribution(),
            financeInterestRate: result.rates?.nominalRate?.percentage,
            financeInterestRateRepresentative: result.rates?.effectiveRate?.percentage,
            financeOfferExpiry: null,
            financeMonthlyInstallment: result.payments?.regularPayment?.grossValue,
        };
    }
}
